module.exports = __webpack_public_path__ + "img/6.4964380a.jpg";